/**
 * anagraficheDaCompletare.js — l'indirizzo dell'elenco «Da completare», in
 * un posto solo per chi lo scrive e per chi ci porta:
 *   - il pulsante «Da completare» della pagina Pazienti
 *     (components/pazienti/PazientiList.jsx), che lo scrive nell'indirizzo;
 *   - il numero accanto alla voce Pazienti del menu
 *     (navigazione/schermate.js, contatoreApre), che e' un collegamento suo
 *     (Alex, 6/10/2026, risposta 22: «il clic sul numero accanto a Pazienti
 *     apre l'elenco GIA' filtrato su "Da completare"»).
 *
 * Perche' una costante e non due: la pagina toglie dall'indirizzo un filtro
 * che non conosce (perche' l'indirizzo non dica un elenco diverso da quello a
 * video). Con due copie, una rinomina del filtro nella pagina avrebbe fatto
 * portare il numero all'elenco intero, senza un errore e senza che nessuno se
 * ne accorgesse: il numero diceva 12, l'elenco ne mostrava cento.
 *
 * La regola di chi conta non sta qui: la decide il server
 * (backend/services/anagraficheDaCompletare.js), che ha lo stesso nome del
 * filtro scritto per conto suo. Lo scenario 1605 dei percorsi li confronta.
 *
 * Fuori da components/: la tabella delle schermate si carica anche in Node
 * (scripts/caricaSchermate.js), che di components/ accetta solo le pagine.
 */

/** Il valore di ?filtro= che accende «Da completare» nella pagina Pazienti. */
export const FILTRO_DA_COMPLETARE = 'da-completare';

/** L'elenco dei pazienti col filtro «Da completare» gia' acceso. */
export const ELENCO_DA_COMPLETARE = `/pazienti?filtro=${FILTRO_DA_COMPLETARE}`;

/**
 * Il nome del numero accanto alla voce Pazienti, per chi non lo vede (il
 * lettore di schermo) e per chi ci passa sopra col mouse: un numero da solo
 * non dice che si clicca, ne' dove porta.
 */
export const descriviNumeroDaCompletare = (n) =>
    `${n} ${n === 1 ? 'anagrafica' : 'anagrafiche'} da completare: apri l'elenco filtrato`;
